import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { LegacyProgressService } from '../../certificates/legacy-progress-service/legacy-progress.service';
import { isIFrameSameOrigin } from '../../shared/helpers/is-same-origin';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { ProgressPageEventType } from '../progress-page-event-type';
import { ShareCertificateComponent } from '../share-certificate/share-certificate.component';
import { IFrameSizeEventType } from '../../shared/types/iframe-event-type';

@Component({
  selector: 'lp2-certificates-section',
  template: `
    <div class="wrapper gamification pb-0">
      <div class="progress-page-wrapper certificates-wrapper pb-3 pt-5">
        <div class="wide anchor" *ngIf="webProgressPageUrl$ | async as url">
          <iframe #certificatesIframe lp2UserwaySync scrolling="no" class="w-100" [src]="url | safeUrl" frameborder="0" [style.height.px]="iframeHeight"></iframe>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['certificates-section.component.scss', '../progress-page/progress-page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CertificatesSectionComponent implements OnInit, OnDestroy {
  modalRef: NgbModalRef;
  webProgressPageUrl$ = new BehaviorSubject<string>(null);
  iframeHeight: number = 670;

  constructor(
    private oeApp: OeAppService,
    private oeAppPersonService: OeAppPersonService,
    public legacyProgressService: LegacyProgressService,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef
  ) {
    this.handleEvents = this.handleEvents.bind(this);
  }

  ngOnInit() {
    this.webProgressPageUrl$.next(
      `${this.oeApp.webProgressPageHost}` +
        `?env=${this.oeApp.environment}` +
        `&personId=${this.oeAppPersonService.id}` +
        `&lang=${this.oeAppPersonService.preferredLang}`
    );

    window.addEventListener('message', this.handleEvents);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleEvents);
  }

  private handleEvents({ data, origin }) {
    if (!isIFrameSameOrigin(this.oeApp.webProgressPageHost, origin)) {
      return;
    }

    const type: ProgressPageEventType | IFrameSizeEventType = data.type;
    switch (type) {
      case ProgressPageEventType.SHARE_CERTIFICATE:
        this.openModal(data);
        break;
      case ProgressPageEventType.DOWNLOAD_CERTIFICATE:
        this.downloadCertificate(data);
        break;
    case IFrameSizeEventType.HEIGHT:
        this.setIframeHeight(data.height);
        break;
    }
  }

  private openModal(data) {
    this.modalRef = this.modalService.open(ShareCertificateComponent, {
      centered: true,
      size: 'lg',
      windowClass: 'full-modal',
    });
    this.modalRef.componentInstance.certificateLevel = data.certificateLevel;
  }

  private downloadCertificate(data) {
    this.legacyProgressService.downloadCertificatePdf(data.certificateLevel);
  }

  private setIframeHeight(height: number) {
    if (height > 0) {
      this.iframeHeight = height;
      this.cdr.detectChanges();
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/progress/certificates-section/certificates-section.component.ts